import { useCallback } from 'react';
import { Slide } from 'react-toastify';

import { useToastThemeStore } from '../../store/toastThemeStore';
import { useToast } from './useToast';

interface UseToastV2ShowOptions {
  /** 토스트 z-index 오버라이드 */
  zIndex?: number;
  /** 토스트 내부 클릭 이벤트 활성화 여부 */
  interactive?: boolean;
}

/**
 * useToast를 wrapping한 V2 버전 훅
 * dark-info 테마를 사용하는 간편한 토스트 표시 기능을 제공합니다.
 */
export const useToastV2 = () => {
  const toast = useToast();
  const setToastZIndex = useToastThemeStore.use.setToastZIndex();

  const show = useCallback(
    (message: React.ReactNode, options?: UseToastV2ShowOptions) => {
      setToastZIndex(options?.zIndex ?? null);
      toast.success(message, {
        position: 'bottom-center',
        autoClose: 3_000,
        hideProgressBar: true,
        closeOnClick: false,
        /** 터치/호버 시 자동 닫기 타이머 일시정지 비활성화 */
        pauseOnHover: false,
        /** 드래그로 토스트 닫기 비활성화 */
        draggable: false,
        /** interactive가 아닌 경우 토스트가 터치 이벤트를 가로채지 않도록 설정 */
        style: { pointerEvents: options?.interactive ? 'auto' : 'none' },
        progress: undefined,
        toastTheme: 'dark-info',
        transition: Slide,
      });
    },
    [toast, setToastZIndex],
  );

  return {
    show,
  };
};
